"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _qs = require("qs");
var _bluebird = _interopRequireDefault(require("bluebird"));
var _basic = _interopRequireDefault(require("./_basic"));
function paramsSerializer(params) {
  return (0, _qs.stringify)(params, {
    arrayFormat: 'brackets'
  });
}
class StoreApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      storeApiUrl
    } = _ref;
    super({
      userTokenFactory
    });
    this.storeApiUrl = storeApiUrl;
  }

  // sb
  async getPackages(params, _ref2) {
    let {
      type,
      signal
    } = _ref2;
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.storeApiUrl}/api/v1/packages/${type}`, {
      headers,
      signal,
      params,
      paramsSerializer
    })).then(response => _bluebird.default.resolve(response.data));
  }

  // library
  async getSandbox(params, _ref3) {
    let {
      type,
      signal
    } = _ref3;
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.storeApiUrl}/api/v1/sandbox/${type}`, {
      headers,
      signal,
      params,
      paramsSerializer
    })).then(response => _bluebird.default.resolve(response.data));
  }

  // sb
  async getCategories(params, _ref4) {
    let {
      type,
      signal
    } = _ref4;
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.storeApiUrl}/api/v1/categories/${type}`, {
      headers,
      signal,
      params
    })).then(response => _bluebird.default.resolve(response.data));
  }
  async putCategory(payload) {
    let {
      type,
      signal,
      headers: customHeaders
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      headers: defaultHeaders
    } = await this.getHeaders();
    const headers = {
      ...defaultHeaders,
      ...customHeaders
    };
    return _bluebird.default.try(() => _axios.default.put(`${this.storeApiUrl}/api/v1/categories/${type}`, payload, {
      headers,
      signal
    })).then(response => _bluebird.default.resolve(response.data));
  }
  async getCategoryById(_ref5, _ref6) {
    let {
      id
    } = _ref5;
    let {
      type,
      signal
    } = _ref6;
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.storeApiUrl}/api/v1/categories/${type}/id/${id}`, {
      headers,
      signal
    })).then(response => _bluebird.default.resolve(response.data));
  }

  // sb
  async getUploadCredentials(payload, _ref7) {
    let {
      type,
      signal,
      headers: customHeaders
    } = _ref7;
    const {
      headers: defaultHeaders
    } = await this.getHeaders();
    const headers = {
      ...defaultHeaders,
      ...customHeaders
    };
    const {
      id,
      version
    } = payload;
    return _bluebird.default.try(() => _axios.default.post(`${this.storeApiUrl}/api/v1/packages/${type}/id/${id}/version/${version}`, payload, {
      headers,
      signal
    }).then(response => _bluebird.default.resolve(response.data)));
  }

  // sb
  async getUploadCredentialsSandbox(payload, _ref8) {
    let {
      type,
      signal
    } = _ref8;
    const {
      headers
    } = await this.getHeaders();
    const {
      id,
      version
    } = payload;
    return _bluebird.default.try(() => _axios.default.post(`${this.storeApiUrl}/api/v1/sandbox/${type}/id/${id}/version/${version}`, payload, {
      headers,
      signal
    }).then(response => _bluebird.default.resolve(response.data)));
  }

  // sb, fb pick ['version', 'baseUrl']
  async getVersions(_ref9, _ref10) {
    let {
      id,
      isSandbox,
      includeDeprecated,
      includeReleaseNotes
    } = _ref9;
    let {
      type,
      signal
    } = _ref10;
    const index = isSandbox ? 'sandbox' : 'packages';
    const {
      headers
    } = await this.getHeaders();
    const params = {
      includeDeprecated,
      includeReleaseNotes
    };
    return _bluebird.default.try(() => _axios.default.get(`${this.storeApiUrl}/api/v1/${index}/${type}/id/${id}`, {
      headers,
      signal,
      params,
      paramsSerializer
    })).then(response => _bluebird.default.resolve(response.data));
  }

  // sb void
  async deletePackageVersionFromSandbox(_ref11, _ref12) {
    let {
      id,
      version
    } = _ref11;
    let {
      type,
      signal
    } = _ref12;
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.delete(`${this.storeApiUrl}/api/v1/sandbox/${type}/id/${id}/version/${version}`, {
      headers,
      signal
    })).then(response => _bluebird.default.resolve(response.data));
  }

  // sb {version}
  async getPackageMetaLatestVersionById(_ref13, _ref14) {
    let {
      id
    } = _ref13;
    let {
      type,
      signal
    } = _ref14;
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.storeApiUrl}/api/v1/packages/${type}/id/${id}/latest`, {
      headers,
      signal
    })).then(response => _bluebird.default.resolve(response.data));
  }

  // datahub, library
  async getMetaByVersion(_ref15, _ref16) {
    let {
      id,
      version,
      isSandbox
    } = _ref15;
    let {
      type,
      signal
    } = _ref16;
    const index = isSandbox ? 'sandbox' : 'packages';
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.storeApiUrl}/api/v1/${index}/${type}/id/${id}/version/${version}`, {
      headers,
      signal
    })).then(response => _bluebird.default.resolve(response.data));
  }
  async getFavorites(params, _ref17) {
    let {
      type,
      signal
    } = _ref17;
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.storeApiUrl}/api/v1/packages/${type}/favorites`, {
      headers,
      signal,
      params,
      paramsSerializer
    })).then(response => _bluebird.default.resolve(response.data));
  }
  async submitLegacyStepJson(stepTemplate) {
    let {
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const type = "STEP";
    const {
      headers
    } = await this.getHeaders();
    const {
      id,
      version = "0.0.1"
    } = stepTemplate;
    const payload = {
      data: stepTemplate,
      name: stepTemplate.label,
      description: stepTemplate.description,
      categories: stepTemplate.categories
    };
    return _bluebird.default.try(() => _axios.default.put(`${this.storeApiUrl}/api/v1/service/sync/${type}/legacy/id/${id}/version/${version}/json`, payload, {
      headers,
      signal
    })).then(response => _bluebird.default.resolve(response.data));
  }
  async syncLegacyStepFromLibrary(_ref18) {
    let {
      id
    } = _ref18;
    let {
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const type = "STEP";
    const {
      headers
    } = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.put(`${this.storeApiUrl}/api/v1/service/sync/${type}/legacy/id/${id}/latest`, {}, {
      headers,
      signal
    })).then(response => _bluebird.default.resolve(response.data));
  }
  async setReleaseStatus(payload) {
    let {
      type,
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      headers
    } = await this.getHeaders();
    const {
      id,
      version,
      scope
    } = payload;
    let {
      repository
    } = payload;
    if (scope && !repository) {
      // scope is deprecated
      console.warn('Using "scope" is deprecated. Use "repository" instead'); // eslint-disable-line no-undef
      repository = scope;
    }
    return _bluebird.default.try(() => _axios.default.post(`${this.storeApiUrl}/api/v1/packages/${type}/id/${id}/version/${version}/status/release/${repository}`, payload, {
      headers,
      signal
    }).then(response => _bluebird.default.resolve(response.data)));
  }
  async setReleaseStatusToBeta(payload) {
    let {
      type,
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const status = "BETA";
    return this.setReleaseStatus({
      ...payload,
      status
    }, {
      type,
      signal
    });
  }
  async setReleaseStatusToReleased(payload) {
    let {
      type,
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const status = "RELEASED";
    return this.setReleaseStatus({
      ...payload,
      status
    }, {
      type,
      signal
    });
  }
  async setReleaseStatusToDeprecated(payload) {
    let {
      type,
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const status = "DEPRECATED";
    return this.setReleaseStatus({
      ...payload,
      status
    }, {
      type,
      signal
    });
  }
  async deprecateLegacyStep(payload) {
    let {
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const type = "STEP";
    return this.setReleaseStatusToDeprecated(payload, {
      type,
      signal
    });
  }
  async deprecateLegacySteps(payload) {
    let {
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      headers
    } = await this.getHeaders();
    const type = "STEP";
    return _bluebird.default.try(() => _axios.default.post(`${this.storeApiUrl}/api/v1/service/sync/${type}/legacy/deprecate`, payload, {
      headers,
      signal
    }).then(response => _bluebird.default.resolve(response.data)));
  }
}
var _default = StoreApi;
exports.default = _default;